/**
 * `YYYY-MM-DD` for the day this date falls on WHERE IT IS READ.
 *
 * The one formatter, shared by both apps, because the obvious alternative is
 * wrong and does not look it: `toISOString().slice(0, 10)` reads the UTC day,
 * which east of UTC is yesterday for the whole early morning. In IST that is
 * every day between midnight and 05:30 — long enough that it always reaches
 * production and never reaches a test run at 3pm.
 *
 * It has already caused this in three separate places here: a calendar dialog
 * that pre-filled the previous day, a due-date floor that permitted yesterday,
 * and an export that saved itself under yesterday's date.
 *
 * Local parts only. Feed it a Date and it answers for that Date's own day.
 */
export function toDateKey(date) {
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${date.getFullYear()}-${month}-${day}`;
}
//# sourceMappingURL=dates.js.map